#!/usr/bin/env node
import { add } from "@/src/commands/add";
import { init } from "@/src/commands/init";
import { Command } from "commander";

import { getPackageInfo } from "./utils/get-package-info";
import {
  ASCII_TEXT,
} from "./utils/logger";

process.on("SIGINT", async () => {
  process.exit(0);
});

process.on("SIGTERM", async () => {
  process.exit(0);
});

async function main() {
  const packageInfo = await getPackageInfo();

  const program = new Command()
    .addHelpText("before", ASCII_TEXT)
    .name("aceternity-ui")
    .description("Add Aceternity UI components to your apps.")
    .version(
      packageInfo.version || "1.0.0",
      "-v, --version",
      "display the version number",
    );

  program.addCommand(init).addCommand(add);
  program.parse();
}

main();
